module.exports = __webpack_public_path__ + "static/media/product.d071a6f6.svg";